import { createAsyncThunk } from "@reduxjs/toolkit";
import { DeleteVouchersNonActivatedPromocodesParams } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const deleteVouchersNonActivatedPromocodes = createAsyncThunk<
  void,
  DeleteVouchersNonActivatedPromocodesParams
>(
  "vouchers/deleteVouchersNonActivatedPromocodes",
  async ({ voucherId, ...params }, { rejectWithValue }) => {
    try {
      await VouchersAPI.deleteVouchersNonActivatedPromocodes({
        voucherId,
        ...params,
      });
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while deleting voucher non-activated promocodes",
          error.response?.data
        );
        return rejectWithValue(error.response?.data || "Unknown error");
      } else {
        console.error("Error while deleting voucher non-activated promocodes", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);